export default __webpack_public_path__ + "static/media/greenCard.006d2f58.svg";